import { createSelector } from '@reduxjs/toolkit';
import { IState } from 'shared/store';
import { IPhotoSchema } from 'shared/types/carousel';

export const getPhotos = createSelector([(state: IState) => state.offerData.offer.photos], photos => {
  return (photos || ([] as IPhotoSchema[])).filter(item => !item.isLayout);
});
